import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr2 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасност при работа с преносими стълби
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>I. Условия за използване на работното оборудване.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Използвайте преносими стълби:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - само в тези случаи, в които не е възможно или не е целесъобразно да се използват
          стационарни стълби, стълби с механично задвижване, скелета, работни платформи и други
          по-удобни и по-безопасни съоръжения;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - така подбрани по вид и размери, че в конкретния случай на използване да осигуряват
          удобни и безопасни условия за работа;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - само по тяхното предназначение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - когато работата не е свързана с придържането на обемисти и тежки товари (кофраж, греди,
          дъски и др.);
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - освен за качване и слизане и за извършване само на леки краткотрайни операции от
          застанало върху стълбата лице;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - когато естеството на работа не изисква едновременното й извършване от повече от един
          човек върху стълба. Когато естеството на работа изисква двама или повече работници, всеки
          работник да ползва самостоятелна стълба;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - само когато теглото на лицето, използващо стълбата със или без допълнителен товар, не
          надвишава допустимото й натоварване.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Не използвайте:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - неизправни стълби;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - стълби с конструкция или изпълнение, неотговарящи на нормативните актове, стандартите и
          техническите условия;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - за извършване на работи по стени и тавани на височина над 3,5 м;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - за изкачване на тежки и обемисти товари (тухли, камъни и други);
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - двураменни стълби и стълби с площадки в работно положение като единични;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преносимите стълби като мостове за преминаване, рампи, подове на работни площадки,
          подпори, хоризонтални носещи елементи на скелета и за други подобни цели.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Не допускайте до работа с преносими стълби лица, които:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не са преминали предварителен медицински преглед и имат медицински противопоказания
          спрямо условията на работа;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не са инструктирани по безопасността, хигиената на труда и противопожарната охрана;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не са в добро здравословно състояние;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не са в трезво състояние;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не са навършили 16 години;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - нямат необходимите лични предпазни средства.
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        <b>II. Предвидими ненормални ситуации.</b>
      </Typography>

      <Typography>
        Преди и след всяка употреба проверявайте визуално състоянието на стълбата:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - <span style={styles.warning}>Внимавайте</span> за повредени, деформирани или липсващи
          елементи.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Проверявайте състоянието и функционирането на подвижните връзки и устройствата за
          застопоряване.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Проверявайте състоянието на противоплъзгащите накрайници.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography>
          <b>За неизправни стълби се считат стълби със следните дефекти:</b>
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *счупени, липсващи и повредени стъпала;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * стъпала, закрепени конзолно само към едната страница (другата страница липсва);
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *стъпала, чиято връзка със страницата е разхлабена;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * дървени стъпала, страници и подпори с недопустими пукнатини и признаци на загниване;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *стъпала с недопустимо износване;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *стъпала, свързани неправилно към страницата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *счупени и повредени страници;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *метални стълби с деформирани (смачкани) стъпала и страници;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *метални стълби с пукнатини и корозирали елементи;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * стълби с приспособление против разтваряне на страните, когато то е повредено, лошо
          закрепено или липсва и когато в крайно положение не осигурява необходимото разтваряне на
          страните на стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *двураменни стълби с разхлабена или счупена шарнирна връзка;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * стълби с площадка и двураменни стълби, чиито страни не могат да се отварят до
          необходимото положение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * стълби с площадка с повредени или липсващи елементи от площадката и нейното
          обезопасяване;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * стълби с неизправни приспособления към тях. Подменяйте счупени, липсващи и повредени
          стъпала с други, равностойни на тях. Връзката между стъпало и страница да бъде равностойна
          на предвидената от производителя. Привеждайте бракуваните стълби в такъв вид, че да е
          невъзможно използването им като стълби.
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        <b>III. Изисквания за безопасност и здраве при работа.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Преносимите стълби се използват само по предназначението си:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - двураменните стълби и стълбите с площадки не се използват като единични;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преносимите стълби не се използват като мост за преминаване, рампи, подове на работни
          площадки и други подобни цели;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преносимата стълба освен за качване и слизане се използва и за извършване само на леки
          краткотрайни операции от лице, застанало върху нея;
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Не се пренасят стълби, когато върху тях има други предмети.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Двураменните стълби и стълбите с площадки се пренасят с прибрани рамена.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          4.
          <span style={styles.warning}>
            <b>Забранено</b>
          </span>{' '}
          е поставянето на стълбите:
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *на места, в които не е осигурено безопасното им използване;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * в непосредствена близост до отвори по подове и стени, до остри и стърчащи предмети, до
          открити съдове с опасни течности и химикали и до други подобни предмети, които могат да
          увеличат тежестта на травмите при падане от стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * на пешеходни пътеки, съобшителни пътища, до незаключени врати, отварящи се към стълбата,
          и други места, където могат да бъдат блъснати и съборени от преминаващи хора или в
          превозни средства. Когато тези изисквания не могат да бъдат спазени, вземете мерки за
          предотвратяване на блъскането на стълбата чрез ограждане, предупредителни надписи и
          табели, организиране на охрана и др.;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * върху варели, сандъци, струпани материали и други нестабилни предмети;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *така, че тя да има за долна и/или горна опорна точка стъпало;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *така, че подпряната единична стълба да бъде наклонена встрани;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * върху опора, по чиято повърхност има разлято масло, боя и други материали, улесняващи
          подхлъзването, когато основата на стълбата не е осигурена срещу подхлъзване чрез механична
          връзка. В този случай да не се разчита на противоплъзгащите се накрайници и на помощта на
          втори човек.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5.Поставяйте стълбите:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * така спрямо зоната на обслужване, че работата да се извършва удобно и безопасно;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * по безопасен начин, гарантиращ тяхната стабилност и непозволяващ отместването им по
          време на използването им;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * върху повърхнина с подходящи размери, която може да осигури стабилността й и да издържи
          натоварването при ползване на стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *върху равен и нехлъзгав терен/под;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          *така, че стъпалата да са хоризонтални;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * така, че тя да се опира върху долната опорна повърхност с края на страниците или със
          специални накрайници;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * така, че горната опора на единична стълба да бъде сигурна, устойчива и здрава, а двата
          горни края на страниците да бъдат стабилно опрени върху опората.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Поставяйте еднораменните стълби</b> в работно положение така, че да имат наклон спрямо
        хоризонтална равнина от 70 до 75° (т.е. разстоянието от основата на стълбата до вертикалната
        линия, спусната от горната опора, да бъде от 1/3 до 1/4 от разстоянието от основата на
        стълбата до горната опора) с цел предотвратяване на нежелано преместване (подхлъзване) на
        опорите.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Поставяйте единични стълби</b>, които водят до горна площадка така, че те да
        надвишават най-малко с 1 м площадката, мерено по страницата, а на стъпалата над нивото на
        площадката не стъпвайте. Надвишаването се постига с по-дълга стълба или чрез прикрепването
        на специална ръкохватка (перило) към една от страниците, като ръкохватка се прави като
        продължение на страниците.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. Когато се налага да се постави стълба </b>на място с оживено движение, се вземат мерки
        за предотвратяване блъскането на стълбата.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Стълби се ползват само след като са</b> поставени така, че при правилното им
        използване да е изключено падане или изместване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. 3а горна опора на единична стълба</b> не се използват прясно боядисани или заледени
        стени, водосточни тръби, кръгли наклонени стълбове, ъгли на сгради, колони, прозорци и други
        нестабилни конструкции.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Единични стълби с дължина над 3 m</b> се закрепват срещу обръщане назад или встрани
        независимо от броя на качванията или времето на използването им.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Двураменните стълби се поставят </b>в работно положение, така че приспособлението
        против недопустимо разтваряне на двете страни да бъде разпънато докрай.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. Стълбите се удължават (наставят)</b> само когато това конструктивно е предвидено от
        производителя.
        <span style={styles.warning}>Забранено</span> е удължаването на стълби чрез заковаване на
        двете части една към друга или свързването им с въжета, тел и други подръчни средства.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. При изкачване (слизане) по стълба </b>и при работа върху стълба използващият я:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да бъде обърнат с лице към нея;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да използва подходящо закопчано работно облекло и подходящи обувки, осигуряващи го срещу
          подхлъзване;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да е с незаети ръце;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да ползва двете си ръце, като се държи за стъпалата, а не за страниците;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - във всеки момент да се държи с една ръка към стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не се наклонява по начин, който би довел до обръщане на стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не заема положения, които я извеждат от положение на равновесие;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не стъпва върху стъпало на единична стълба, когато от него до горния край на
          страницата остава по-малко от 1 м. Разстоянието от 1 м не се спазва, когато стълбата служи
          за изкачване на площадка и страницата е удължена като перило;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не стъпва върху най-горните стъпала на двураменните стълби;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не застава върху стълбата на един крак, като другият виси встрани или е стъпил върху
          друг предмет;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да използва стълбата така, че по всяко време да може да се захваща здраво и да има
          здрава опора;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да работи с инструменти или други леки малогабаритни предмети само с една ръка, а с
          другата ръка най-много да придържа предмети като пирони, габър, шило и др.;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не слага и оставя на стъпалата й инструменти или материали.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body1" style={styles.whiteSpace}>
          <b>15. Върху стълба не се качва повече от едно лице</b>, независимо дали стълбата е
          единична или двойна. Когато естеството на работа изисква двама или повече работници, всеки
          работник използва самостоятелна стълба.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16. Не се стои под стълба</b>, когато върху нея има работещ.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>17. На лице, намиращо се върху стълба</b>, не се подават материали и предмети чрез
        подхвърляне.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>18. При използване на единични стълби </b>с дължина по-голяма от 5 м, се вземат мерки
        срещу деформиране (подпиране в средата и др.).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>19. Не се разрешава масата на лицето, използващо стълба</b> (включително и товара), да
        превишава посочената от производителя на стълбата маса. Когато масата не е посочена, се
        приема 120 kg.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. Приплъзването на опорите на преносимите стълби</b> по време на използване се
        предотвратява чрез закрепване на страничните им греди при или в близост до горните и/или
        долните им краища чрез приспособление срещу приплъзване или чрез друго равностойно по
        ефективност приспособление. Когато мерките посочени по-горе не могат да се приложат,
        единичните стълби се осигуряват срещу подхлъзване
        <b>чрез придържане от човек пред стълбата или встрани от нея.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>21. Носете каска с подбрадник в случаите</b>, при които работите на височина над 1,5 м.
        измерено от пода или от терена.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>22. При работа с преносими стълби </b>в близост до тоководещи части под напрежение се
        спазват и изискванията, произтичащи от специфичните условия за работа с електрически уредби.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>23. При работа върху стълб</b>, единичните стълби с дължина по-голяма от 5 м,
        задължително се обезопасяват срещу приплъзване с помощта на колан, чийто краища са захванати
        здраво за стъпало. Коланът се навива около стълба, перпендикулярно на равнината на стълбата.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>24. При изпълнение на работните задачи</b> не използвайте чужди стълби, а само
        осигурените ви от работодателя!
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>25. Не се допуска:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - удължаване (наставяне) на единични или двойни преносими стълби освен в случаите, когато
          това е предвидено от производителя;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - използване в работно положение на двураменни стълби, както и на такива с площадки като
          единични;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преместване на стълба с работещ или предмети, намиращи се на нея;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преместване на двураменна стълба с неприбрани рамена или чрез усилието на намиращия се
          на нея работещ;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - заставане върху стълба на един крак, като другият виси встрани или е стъпил върху друг
          предмет;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - поставяне и оставяне на инструменти и др. на стъпалата на стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - стълбата да има за долна и/или горна опорна точка стъпало;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - движение и работа по стълби, когато стъпалата им са покрити с вещества или материали,
          улесняващи подхлъзването;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - заемане от лицето, извършващо работна операция от стълба, на положения, които могат да я
          изведат от положение на равновесие.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body1" style={styles.whiteSpace}>
          <b>26. Пренасяне на товари при движение по стълби</b> извършвайте само в случаи, в които е
          невъзможно или нецелесъобразно пренасянето им посредством други, по-удобни и по-безопасни
          начини - чрез въже, подемни устройства, директно подаване от ръка на ръка и др.
          Инструменти и леки предмети носете в чанта, закачена за колана или носена през рамо.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>27. Пренасяният по стълба товар:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не надвишава 20 кг, а при използване на стълби, удължени чрез наставяне - 10 кг;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се носи по такъв начин, че двете ръце на лицето да бъдат свободни, а центърът на
          тежестта на лицето заедно с товара да не излиза извън опорния контур на стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се носи удобно, без да възпрепятства движението и сигурното захващане на ползващите
          я;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да може да се поеме (оставя) безопасно.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>28. Не подавайте</b> на лице, намиращо се върху стълба, материали и предмети чрез
        подхвърляне.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>29. Не стойте под стълба</b>, върху която се работи.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>30. Не прикрепвайте към стълби подемни съоръжения</b> (макари, лебедки и др.).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>31. Не допускайте</b> работа от стълба на височина, по-голяма от 3 м от основата на
        стълбата от лице, което не е закрепено посредством предпазен колан към здрава и сигурна
        конструкция.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>32. Почиствайте стълбите</b> от разлети течности и петна.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>33. Пазете ги от замърсяване</b> с мазнини, бои и други хлъзгави материали.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>34. Смазвайте връзките</b> на подвижните елементи.
      </Typography>

      <Typography>
        <b>Съхранение на преносими стълби</b>
      </Typography>

      <Typography>
        Съхранявайте стълбите, когато не се използват, на такива места и по такъв начин, че:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да е осигурен удобен и безопасен достъп до тях;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да е осигурено безопасното им поставяне и изваждане;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да са осигурени срещу падане;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да са защитени от механични повреди, влага, силна топлина и други неблагоприятни
          въздействия;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да не се получават недопустими деформации в тях.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - неизправните стълби да не могат да се ползват.
        </Typography>
      </div>

      <Typography>
        Не съхранявайте стълбите, поставени непосредствено една върху друга или с поставен товар
        върху тях.
      </Typography>

      <Typography>Проветрявай редовно и добре местата, в които се съхраняват стълби.</Typography>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        <b>IV. Извлечени от опит заключения при използването на работното оборудване.</b>
      </Typography>

      <Typography>
        След приключване на работа, стълбите да се поставят на определените места за съхранение, а
        при кратък престой да се вземат мерки против използването им от странични лица.
      </Typography>

      <Typography>
        Мястото за съхранение трябва да бъде с удобен и безопасен достъп до стълбите и да гарантира
        безопасното им поставяне и изваждане.
      </Typography>

      <Typography>
        Стълбите да се съхраняват на сухо място, далеч от влага, пряк източник на топлина, опасни
        химически вещества и други фактори с неблагоприятно въздействие.
      </Typography>

      <Typography>
        Да не се съхраняват стълби в работно положение. Да не се съхраняват стълби в положение, при
        което съществува риск от падане или деформации: поставени непосредствено една върху друга, с
        поставен товар върху тях и др. При работа със стълби, каска се използва в следните случаи:
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Когато има риск от падащи предмети</b> - ако работите под други работници, близо до
        строителни обекти или под конструкции, от които могат да паднат инструменти или материали.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При използване на високи стълби </b>- ако работите на значителна височина (над 1,5
        метра) от пода или терена, където падането може да причини сериозни наранявания.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. При работа в тесни или промишлени пространства </b>- например в складове, фабрики, при
        монтаж на инсталации или в близост до машини и съоръжения.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. При нестабилна или наклонена повърхност</b> - ако стълбата е разположена върху неравен
        терен, съществува риск от падане и удар.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. При работа на стълба с друг работник отдолу </b>- ако двама души работят заедно,
        каската предпазва от случайни удари с инструменти или части от оборудването.
      </Typography>

      <Typography>
        Спазването на правилата за безопасност, включително използването на каска, намалява риска от
        сериозни наранявания при работа със стълби!
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr2;
